import React, { useEffect } from "react"
import SiteHeader from "../components/site-header"
import PageMetadata from "../components/page-metadata"
import { Location } from "@reach/router"
import SiteFooter from "../components/site-footer"
import { ToastContainer } from "react-toastify"

const Layout = ({ children }) => {
  const handleKeydown = event => {
    if (event.keyCode === 9 || event.keyCode === 13) {
      document.body.classList.add("user-is-tabbing")
    }
  }

  const handleClick = e => {
    if (e.detail === 1) {
      document.body.classList.remove("user-is-tabbing")
    }
  }

  const getPage = pathname => {
    let base = pathname.split("/")
    let lastSegment = base.pop() || base.pop()
    if ((lastSegment === "") | (lastSegment === "eng")) {
      return "home"
    } else {
      return lastSegment
    }
  }

  useEffect(() => {
    window.addEventListener("click", handleClick)
    return () => {
      window.removeEventListener("click", handleClick)
    }
  })

  useEffect(() => {
    window.addEventListener("keydown", handleKeydown)
    return () => {
      window.removeEventListener("keydown", handleKeydown)
    }
  })

  return (
    <Location>
      {({ location }) => (
        <>
          <PageMetadata template={getPage(location.pathname)} />
          <a className="skip-main" href="#main">
            Skip to main content
          </a>
          <SiteHeader path={location.pathname} hash={location.hash} />
          <span className="anchor" id="main" tabIndex="-1" />
          <main>{children}</main>
          <ToastContainer limit={1} role="dialog" />
          <SiteFooter path={location.pathname} />
        </>
      )}
    </Location>
  )
}

export default Layout
